<template>
  <div>
    <carousel
            :perPageCustom="perPageCustom"
            :scrollPerPage="scrollPerPage"
            :paginationEnabled="paginationEnabled"
            :navigationEnabled="navigationEnabled"
            :autoplay="autoplay"
            :autoplayTimeout="autoplayTimeout"
            :centerMode="centerMode">
      <slide v-for="(video, index) in fetchVideos" :key="index">
        <slot :video="video" name="slide-card"></slot>
      </slide>
    </carousel>
  </div>
</template>

<script>
  import slider from '@fremcast/section/mixins/slider';
  import section from '@fremcast/section/mixins/section';
  import video from '@fremcast/section/mixins/videos';
  export default {
    mixins: [
      slider,
      section,
      video
    ]
  }
</script>

<style scoped>
  .video-card {
    margin-left: 10px;
  }

  img {
    height: 130px;
    object-fit: cover;
  }

</style>
